import React from 'react';

import Layout from '../components/layout';
import Wizard from '../components/wizzard';
import { getResultCookie, nextRedirect } from '../service/helpers';
import { NODE_ENV } from '../service/variables';
import { loadQuizImages, loadStep } from '../store/quiz/thunks';
import { FunctionalPage } from '../types/store-types';

export type IndexProps = { onComplete: () => void };

const Index: FunctionalPage<IndexProps> = ({ onComplete }) => {
  return (
    <Layout fullHeightStyle withFooterStyle contentStyle={true}>
      <Wizard onComplete={onComplete} />
    </Layout>
  );
};

Index.getInitialProps = async (ctx) => {
  const { store, query, res } = ctx;
  const lastResult = getResultCookie(ctx);
  if (res && lastResult) {
    await nextRedirect(res, lastResult);
    return;
  }
  if (res && query.step && NODE_ENV !== 'development') {
    await nextRedirect(res, '/');
    return;
  }
  if (typeof query.step === 'string') {
    await store.dispatch(loadStep(query.step));
  } else {
    await Promise.all([store.dispatch(loadStep()), store.dispatch(loadQuizImages())]);
  }
};

export default Index;
